import styled from "styled-components";

export const StickyActions = styled.div`
  background: #fff;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1);
  width: 100%;
  padding: 12px 40px;

  .ant-row.ant-form-item {
    padding-bottom: 0;
    margin-bottom: 0;
  }
`;
